import React, {useContext, useEffect, useRef, useState} from "react";
import Loading from "components/Loading";
import {OutlinePrimaryBtn, SolidPrimaryBtn, SolidPrimarySubBtn, SolidRedBtn} from "components/button/Button";
import {
    CustomDatePickerWrap, EllipsisTextColumn, FlexGrow, ListContentWrap,
    PageArticleWrap,
    PageHeaderTitleButtonStyle,
    TwoListContentWrap
} from "components/layout/Layout";
import ReactDatePicker from "react-datepicker";
import {addMonths, getMonth, getYear, subMonths} from "date-fns";
import {CustomCheckbox, selectOption, SelectOption} from "components/input/Input";
import styled from "styled-components";
import {
    aesCBCDecrypt,
    aesCBCEncrypt, getUserImageUrl,
    handleImageUpload,
    MONTHS,
    NoTeacherDataText,
    ROLE_DIRECTOR,
    ROLE_TEACHER
} from "../../utils/commonUtils";
import refreshIcon from "../../assets/image/common/refresh.svg";
import {
    ClassInfo,
    ClassQueryParams, CommonResult,
    ListResult,
    StudentInfo, UserImageType,
    UserInfo, UserPostType,
    UserQueryParams,
    UserSiteInfo, UserSiteRequestType
} from "../../type/type";
import {createUserHandler, getClass, getImageUrl, getUser, userApproval} from "../../api/api";
import {NoDataWithImageText} from "components/NoDataComponent";
import DefaultProfileS from "../../assets/image/common/default_profile_S.svg";
import {colors} from "../../styles/global-styles";
import {RoundBigImage, RoundImage, RoundImageContainer} from "components/common/Image";
import {DefaultModalComponent, ModalPropsInterface, ModalTitle, ModalType} from "components/ModalComponent";
import {handleInputChange} from "react-select/dist/declarations/src/utils";
import {useLoginUserInfo} from "../../redux/hook/useLoginUserInfo";

const JoinNavWrap = styled.nav`
    display:flex;
    gap: 1rem;
    flex-direction: row;
    align-items: center;
`;

const ColumnFlex = styled.div`
    justify-content: end!important;
    gap: 0.5rem;
`;

const ArticleWrap = styled.div`
  width: 100%;
  height: calc(100% - 3.75rem);
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const FilterContainer = styled.nav`
  background-color: ${({theme}) => theme.rootWhite};
  padding: 1rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 2rem;
`;

const FilterWrap = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  min-width: 12.5rem;
  > div {
    width: 100%;
  }
  > label{
      min-width:3rem;
  }
`;

const CheckBoxWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
`;

const NoDataWrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`

const TableColumn = styled.div`
  min-height: 3.75rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  > div {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    &:nth-of-type(6) {
      word-break: auto-phrase;
    }
  }
  .thumbnail-wrap {
    max-height: 5rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &:hover {
    background-color: ${({theme}) => theme.newTheme.table.tableBodyHoverBg};
  }
`;

const InputWrap = styled.div`
  width: 100%;
  display: flex;
    
`;
const InputWrapC = styled(InputWrap)`
  flex-direction: column;
  gap: 0.8rem;
  padding-bottom: 1rem;
`;

const ImageOneWrap = styled.div`
  //width: calc((100% - 1.5rem) / 6);
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  //border: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .preview-image {
    height: 100%;
    width:100%;
    border-radius: 50%;
  } 
  .carema-icon {
    position: absolute;
    top: 75%;
    left: 70%;
  }  
  .delete-preview-image {
    display: none;
    position: absolute;
    top: 1px;
    right: 1px;
  }
  &:hover {
    cursor: pointer;
    img:not(.cancel-icon),
    label {
      opacity: 0.7;
    }
    .delete-preview-image {
      display: block;
    }
  }
`;

//가로 content
const RowContentWrap = styled.div`
    width: 100%;
    display: flex;
`;

//left content
const RowContentLeftWrap = styled.div`
    width: 25%;
    .file-wrap {
        padding-right: 2rem;
        width:100%;
    }
`;

//right content
const RowContentRightWrap = styled.div`
    width: 75%;
`;


interface TeacherListViewerProps{
    teacherList: UserInfo[];
    allApprovalCheck: boolean;
    allSelectTeacherCheck: boolean;
    setAllSelectTeacherCheck: (value:boolean) => void;
    selectTeacherIdList: number[];
    handleSelectTeacherId: (teacherId:number) => void;
    handleAllSelectTeacherId: () => void;
    updateApproval: (teacherId:number,approval:number) => void;
}

/**
 * 선생님 테이블 컴포넌트
 * @param teacherList 선생님 정보 리스트
 * @param allApprovalCheck 승인완료 숨기기 체크박스 상태
 * @param allSelectTeacherCheck 모든 선생님 ID 체크박스 상태
 * @param setAllSelectTeacherCheck 모든 선생님 ID 체크박스 상태 변경 이벤트
 * @param selectTeacherIdList 체크 선택된 선생님 ID 체크박스
 * @param handleSelectTeacherId 선생님 ID 체크박스 선택 이벤트
 * @param handleAllSelectTeacherId 모든 선생님 ID 체크박스 선택 이벤트
 * @param updateApproval 승인 요청 함수
 * @constructor
 */
const TeacherListViewer:React.FC<TeacherListViewerProps> = ({teacherList,
                                                            allApprovalCheck,
                                                            allSelectTeacherCheck,
                                                            setAllSelectTeacherCheck,
                                                            selectTeacherIdList,
                                                            handleSelectTeacherId,
                                                            handleAllSelectTeacherId,
                                                            updateApproval}) => {

    useEffect(() => {
        //모든 선생님이 선택되었을때, all 체크박스 체크
        if (teacherList.length > 0 && selectTeacherIdList.length === teacherList.length) {
            setAllSelectTeacherCheck(true);
        } else {
            setAllSelectTeacherCheck(false);
        }
    }, [selectTeacherIdList]);

    return (
        <ListContentWrap>
            <div className="list-one-wrap" style={{paddingTop: '1rem'}}>
                <div className="list-table">
                    <nav className="list-table-header">
                        <div className="w-5">
                            <CustomCheckbox style={{marginLeft:'6px'}}
                                            type="checkbox"
                                            checked={allSelectTeacherCheck}
                                            onClick={handleAllSelectTeacherId}/>
                        </div>
                        <div className="w-10">사진</div>
                        <div className="w-8">이름</div>
                        <div className="w-8">직책</div>
                        <FlexGrow className="w-15">담당 반</FlexGrow>
                        <div className="w-8">연락처</div>
                        <div className="w-20">승인 상태</div>
                    </nav>

                {/*선생님 리스트 출력*/}
                {teacherList.map((teacher,index)  => {
                    //승인완료 숨기기
                    if(allApprovalCheck && teacher.approval === 1){
                        return null;
                    }

                    let approvalText = "";
                    let approvalColor = "";

                    switch (teacher.approval) {
                        case 0:
                            approvalText = "승인 대기";
                            approvalColor = "text-yellow";
                            break;
                        case 1:
                            approvalText = "승인 완료";
                            approvalColor = "text-gray";
                            break;
                        case 2:
                            approvalText = "승인 거절";
                            approvalColor = "text-red";
                            break;
                    }

                    return (
                        <TableColumn key={teacher.id}>
                            <div className="w-5">
                                <CustomCheckbox type="checkbox"
                                                value={teacher.id}
                                                checked={selectTeacherIdList.includes(teacher.id)}
                                                onClick={()=> {handleSelectTeacherId(teacher.id)}}/>
                            </div>
                            <RoundImageContainer className="w-10">
                                <RoundBigImage src={teacher.image_url} alt="profile"/>
                            </RoundImageContainer>
                            <div className="w-8">{aesCBCDecrypt(teacher.name)}</div>
                            <div className="w-8">{teacher.role === ROLE_DIRECTOR ? "원장" : "선생님"}</div>
                            {/*선생님이 담당하는 반 리스트*/}
                            <FlexGrow className="w-15">
                                <EllipsisTextColumn>
                                    {teacher.class_name_list.map((className, index) => (
                                        <span key={index}>
                                            {className}
                                            {index < teacher.class_name_list.length - 1 && ',  '}
                                        </span>
                                    ))}
                                </EllipsisTextColumn>
                            </FlexGrow>
                            <div className="w-8">{teacher.phone ? aesCBCDecrypt(teacher.phone) : ""}</div>
                            <ColumnFlex className="w-20">
                                <span style={{fontWeight: 'bold'}} className={approvalColor}>{approvalText}</span>

                                {teacher.approval === 1 ? (
                                    //이미 승인 완료된 상태라면 버튼 비활성화
                                    <>
                                        <OutlinePrimaryBtn className="default-btn" style={{padding:'0.5rem 1rem'}} disabled>승인</OutlinePrimaryBtn>
                                        <OutlinePrimaryBtn className="default-btn" style={{padding:'0.5rem 1rem'}} disabled>거절</OutlinePrimaryBtn>
                                    </>
                                ) : (
                                    <>
                                        <SolidPrimarySubBtn className="default-btn" style={{padding:'0.5rem 1rem'}} onClick={() => {updateApproval(teacher.id,1)}}>승인</SolidPrimarySubBtn>
                                        <SolidRedBtn className="default-btn" style={{padding:'0.5rem 1rem'}} onClick={() => {updateApproval(teacher.id,2)}}>거절</SolidRedBtn>
                                    </>
                                )}
                            </ColumnFlex>
                        </TableColumn>
                    )
                })}
                </div>
            </div>
        </ListContentWrap>
    )
}

export const BusSchedule = () => {

    const {access, user, selectSiteId} = useLoginUserInfo();
    const [loading, setLoading] = useState<boolean>(true);

    //승인완료 숨기기 체크박스 상태
    const [allApprovalCheck, setAllApprovalCheck] = useState<boolean>(false);

    //사용자 중 선생님만 필터링한 목록
    const [teacherList, setTeacherList] = useState<UserInfo[]>([]);

    //모든 선생님 ID 체크박스
    const [allSelectTeacherCheck, setAllSelectTeacherCheck] = useState<boolean>(false);

    //목록 선생님 ID 체크박스
    const [selectTeacherIdList, setSelectTeacherIdList] = useState<number[]>([]);

    //직책 선택 옵션
    const [roleSelectOptions, setRoleSelectOptions] = useState<selectOption[]>([
        { value: 0, label: "전체" },
        { value: 1, label: "원장" },
        { value: 2, label: "선생님" },
    ]);

    //반 선택 옵션
    const [classSelectOptions, setClassSelectOptions] = useState<selectOption[]>([
        { value: 0, label: "전체" },
    ]);

    const defaultRequestTeacher: UserPostType = {
        user_site_list: [{
            site_id: selectSiteId,
            approval: 1,
        }],
        name: "", // 암호화 필요
        email: "", // 암호화 필요
        phone: "", // 암호화 필요
        role: "ROLE_TEACHER", // 사용자 권한 (ROLE_DIRECTOR, ROLE_TEACHER, ROLE_PARENT만 유효)
        login_id: "",
        login_pw: "", // 암호화 필요
        temp_phone: "", // 암호화 필요
        terms_agree: 0, // 0: 미동의, 1: 동의
        unique_code: "", // 사용자 고유 코드 (단말기 사번)
        card_no: "",
        class_id: 0, // ROLE_TEACHER(선생님)인 경우 유효, 이외 0으로 설정
        student_id: 0, // ROLE_PARENT(학부모)인 경우 유효, 이외 0으로 설정
        temp_mobile_os: 0, // 1: Android, 2: IOS (회원 가입시 승인 push발송을 위한 모바일 OS) (web은 해당 없음)
        temp_mobile_token: "", // 회원 가입시 승인 push 발송을 위한 임시 토큰 (web은 해당 없음)
        base64_list: [],
    };

    //사용자 등록 시
    const [requestTeacher, setRequestTecher] = useState<UserPostType>(defaultRequestTeacher);

    //모달 오픈 시 requestTeacher 초기화 함수
    const initRequestTeacher = () => {
        setRequestTecher(defaultRequestTeacher);
    };

    //사용자 API 파라미터
    const [userQueryParams, setUserQueryParams] = useState<UserQueryParams>({
        site_id: selectSiteId,
        name: "",
        page: 1,
        size: 1000,
        class_id:0,
        role:"",
        role_number: 0,
        student_name: "",
    });

    const imageInput = useRef<HTMLInputElement>(null);

    //모달 상태
    const [modalProps, setModalProps] = useState<ModalPropsInterface>({
        isOpen: false,
        isClose: () => {},
        title: "",
        content: null,
        button: null,
        type: ""
    });

    //반 등록/수정 모달 열기 버튼 클릭 시
    const openModal = (modalType:ModalType) => {
        let title: ModalTitle = "";
        let content:JSX.Element = <></>;
        let button:JSX.Element = <></>;
        switch (modalType) {
            case "createTeacher":
                title = "선생님 신규 등록";
                break;
            case "updateTeacher":
                title = "선생님 정보 수정";
                break;
        }

        setModalProps({
            isOpen: true,
            isClose: () => setModalProps({...modalProps, isOpen: false}),
            title: title,
            content: content,
            button: button,
            type: modalType
        });
    }

    /**
     * 선생님 등록 모달 컨텐츠
     * @constructor
     */
    const TeacherModalContent = ():JSX.Element => {

        //선생님 등록 API 호출
        const handleCreateTeacher = async():Promise<void>=> {

            if(!requestTeacher.name){
                alert("이름을 입력해주세요.");
                return;
            }

            if(!requestTeacher.login_id){
                alert("로그인 아이디를 입력해주세요.");
                return;
            }

            if(!requestTeacher.login_pw){
                alert("로그인 비밀번호를 입력해주세요.");
                return;
            }

            try{
                //requestTeacher 객체 복사
                const requestTeacherCopy = { ...requestTeacher };

                //이름, 비밀번호, 이메일, 연락처, 암호화
                if(requestTeacherCopy.name){
                    requestTeacherCopy.name = aesCBCEncrypt(requestTeacherCopy.name);
                }

                if(requestTeacherCopy.login_pw){
                    requestTeacherCopy.login_pw = aesCBCEncrypt(requestTeacherCopy.login_pw);
                }

                if(requestTeacherCopy.email){
                    requestTeacherCopy.email = aesCBCEncrypt(requestTeacherCopy.email);
                }

                if(requestTeacherCopy.phone){
                    requestTeacherCopy.phone = aesCBCEncrypt(requestTeacherCopy.phone);
                }



                const res:CommonResult = await createUserHandler(requestTeacherCopy);
                if(res.code === 200){
                    alert("선생님 등록이 완료되었습니다.");
                    getTeacherList();
                    setModalProps({...modalProps, isOpen: false});
                }
                else{
                    alert(res.message);
                }

            }
            catch (e) {
                console.error(e);
            }
        }

        //선생님 등록 정보 업데이트
        function updateRequestUser(updates: Partial<UserPostType>) {
            setRequestTecher({
                ...requestTeacher,
                ...updates,
            });
        }

        const setBase64Image = (base64: string) => {
            //이미지는 1개만 등록할수 있게, 배열 초기화 후 추가
            setRequestTecher({
                ...requestTeacher,
                base64_list: [...[], base64]
            });
        };

        //input 값 변경 이벤트
        const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            const { name, value } = e.target;
            updateRequestUser({ [name]: value }); // 상태 업데이트
        };
        //select 값 변경 이벤트
        const handleInputChangeSelect = (value:number) => {
            updateRequestUser({class_id:value});
        }
        //이미지 파일 변경 이벤트
        const onImageChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
            const base64Files:string[]|undefined = await handleImageUpload(event);
            if (base64Files && base64Files.length > 0) {
                setBase64Image(base64Files[0]);
            }
        };




        // 파일 선택 - input 클릭 시(사진)
        const handleImageFileClick = (e: any) => {
            imageInput.current?.click();
        };

        //클래스 선택 옵션 깊은 복사
        const classSelectOptionsCopy = JSON.parse(JSON.stringify(classSelectOptions));

        //전체 문구를 미지정으로 변경
        classSelectOptionsCopy[0].label = "미지정";

        return (
            <>
                <RowContentWrap>
                    <RowContentLeftWrap>
                        <div className="file-wrap">
                            <ImageOneWrap onClick={handleImageFileClick}>
                                <img
                                    className="preview-image"
                                    srcSet={requestTeacher.base64_list && requestTeacher.base64_list[0] ? requestTeacher.base64_list[0] : DefaultProfileS}
                                    alt=""
                                />
                                <img className="carema-icon" src="/image/icon/camera-background.svg" alt="camera"/>
                                <input
                                    type="file"
                                    name="file"
                                    onChange={(e) => onImageChange(e)}
                                    accept=".jpg, .png, .jpeg"
                                    style={{display: "none"}}
                                    ref={imageInput}
                                    multiple
                                />
                            </ImageOneWrap>

                        </div>
                    </RowContentLeftWrap>
                    <RowContentRightWrap>

                        <InputWrap>
                            <InputWrapC>
                                <label>이름</label>
                                <input type="text" name="name" value={requestTeacher.name} onChange={handleInputChange}
                                       placeholder="선생님 이름 입력"/>
                            </InputWrapC>
                        </InputWrap>

                        <InputWrap>
                            <InputWrapC>
                                <label>로그인 아이디</label>
                                <input type="text" name="login_id" value={requestTeacher.login_id} onChange={handleInputChange}
                                       placeholder="아이디 입력"/>
                            </InputWrapC>
                        </InputWrap>

                        <InputWrap>
                            <InputWrapC>
                                <label>로그인 비밀번호</label>
                                <input type="password" name="login_pw" value={requestTeacher.login_pw} onChange={handleInputChange}
                                       placeholder="비밀번호 입력"/>
                            </InputWrapC>
                        </InputWrap>

                        <InputWrap>
                            <InputWrapC>
                                <label>이메일 주소</label>
                                <input type="text" name="email" value={requestTeacher.email} onChange={handleInputChange}
                                       placeholder="이메일 주소 입력"/>
                            </InputWrapC>
                        </InputWrap>

                        <InputWrap>
                            <InputWrapC>
                                <label>연락처</label>
                                <input type="text" name="phone" value={requestTeacher.phone} onChange={handleInputChange}
                                       placeholder="연락처 입력"/>
                            </InputWrapC>
                        </InputWrap>

                        <InputWrap>
                            <InputWrapC>
                                <label>담당 반 지정</label>
                                <SelectOption optionData={classSelectOptionsCopy}
                                              defaultValue={requestTeacher.class_id}
                                              onChange={(class_id: number) => {
                                                  handleInputChangeSelect(class_id)
                                              }}/>
                            </InputWrapC>
                        </InputWrap>

                    </RowContentRightWrap>
                </RowContentWrap>
                <SolidPrimaryBtn className="default-btn" style={{width:"100%"}} onClick={handleCreateTeacher}>
                    등록 완료
                </SolidPrimaryBtn>
            </>
        )
    }



    /**
     * 반 select option에 추가하기 위한 API
     */
    const getClassList = async () => {
        try{

            const requestClassParams:ClassQueryParams = {
                response_format:"",
                name:"",
                user_id:0,
                page: 1,
                size: 1000
            }

            const res:ListResult<ClassInfo> = await getClass(requestClassParams);
            if(res.code === 200){
                //반 select option에 추가
                const newOptions = res.data.map((classInfo: ClassInfo) => ({
                    value: classInfo.id,
                    label: classInfo.name,
                }));

                setClassSelectOptions((prev) => {
                    // value가 0인 옵션만 남김
                    const filteredOptions = prev.filter((option) => option.value === 0);
                    // 새 옵션 추가
                    return [
                        ...filteredOptions,
                        ...newOptions, // 여러 개의 새 옵션 추가
                    ];
                });
            }
        }
        catch (e) {
            console.error(e);
        }
    }


    /**
     * 선생님 목록 조회
     */
    const getTeacherList = async () => {

        try{

            const res:ListResult<UserInfo> = await getUser(userQueryParams);

            if(res.code === 200){
                const userList:UserInfo[] = res.data;
                //선생님만 추출
                const teacherList = userList.filter((user) => (user.role === ROLE_DIRECTOR || user.role === ROLE_TEACHER));

                //user_site_list에서 selectSiteId와 일치하는 approval(승인 여부)를 approval로 변경
                for (const teacher of teacherList) {
                    const userSite:UserSiteInfo|undefined = teacher.user_site_list.find((userSite) => userSite.site_id === selectSiteId);
                    const approval = userSite?.approval;
                    const approvalDate = userSite?.approval_date;
                    teacher.approval = approval || 0;
                    teacher.approval_date = approvalDate || "";

                    //담당 반 이름 조회
                    teacher.class_name_list = await fetchClassName(teacher.id);
                }

                //모든 선생님 이미지 URL 조회
                setTeacherList(await getUserImageUrl(teacherList));

                setLoading(false);
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * 선생님이 담당하는 반 이름 조회
     * @param userId
     */
    const fetchClassName = async (userId:number) => {
        const classNameList:string[] = [];
        const requestClassParams:ClassQueryParams = {
            response_format:"",
            name:"",
            user_id:userId,
            page: 1,
            size: 1000
        }

        const res:ListResult<ClassInfo> = await getClass(requestClassParams);
        if(res.code === 200){
            classNameList.push(...res.data.map((classInfo:ClassInfo) => classInfo.name));
        }
        return classNameList;
    }

    /**
     * 단일 승인 요청
     * @param teacherId
     * @param approval
     */
    const updateApproval = async (teacherId:number,approval:number) => {
        try{
            const res:CommonResult = await userApproval(teacherId,approval);
            if(res.code === 200) {
                let title = "승인이 완료되었습니다.";
                if(approval === 2){
                    title = "승인이 거절되었습니다.";
                }

                alert(title);
                getTeacherList();
            }
        }
        catch (e) {
            console.error(e);
        }
    };

    /**
     * 일괄 승인 요청
     */
    const updateAllApproval = async () => {

        try{
            if(selectTeacherIdList.length <= 0){
                alert("선택된 선생님이 없습니다.");
                return;
            }

            //선택한 선생님 중 승인 대기인 선생님만 추출
            const approvalTeacherList:UserInfo[] = teacherList.filter((teacher:UserInfo) =>
                selectTeacherIdList.includes(teacher.id) && (teacher.approval === 0 || teacher.approval === 2)
            );

            if(approvalTeacherList.length <= 0){
                alert("선택된 선생님 중 승인 대기인 선생님이 없습니다.");
                return;
            }

            const allRequest = approvalTeacherList.map(async (teacher:UserInfo ) => {
                // console.log("승인 요청 선생님 ID : ", teacher.id);
                const res:CommonResult = await userApproval(teacher.id,1);
            });

            await Promise.all(allRequest);
            alert("승인 요청이 완료되었습니다.");
            getTeacherList();
            setAllSelectTeacherCheck(false);


        }
        catch (e) {
            console.error(e);
        }

    }



    const handleSelectTeacherId = (teacherId:number) => {
        //이미 체크된 선생님 ID라면 체크 해제
        if(selectTeacherIdList.includes(teacherId)){
            setSelectTeacherIdList(selectTeacherIdList.filter((id) => id !== teacherId));
        }
        //체크되지 않은 선생님 ID라면 체크
        else{
            setSelectTeacherIdList([...selectTeacherIdList, teacherId]);
        }
    }

    //모든 선생님 체크
    const handleAllSelectTeacherId = () => {
        //모든 선생님 체크 해제
        if(selectTeacherIdList.length === teacherList.length){
            setSelectTeacherIdList([]);
        }
        //모든 선생님 체크
        else{
            const teacherIdList = teacherList.map((teacher) => teacher.id);
            setSelectTeacherIdList(teacherIdList);
        }
    }


    //사용자 검색 조건 변경
    function changeUserQueryParams(updates: Partial<UserQueryParams>) {
        setUserQueryParams({
            ...userQueryParams,
            ...updates,
        });
    }
    //직책 선택 옵션 변경
    function handleRoleSelectOptions(role_number: number) {
        changeUserQueryParams({role_number:role_number});
        //role_number가 0이면 전체, 1이면 원장, 2이면 선생님
        changeUserQueryParams({role: role_number === 0 ? "" : role_number === 1 ? ROLE_DIRECTOR : ROLE_TEACHER});
    }

    //선생님 이름 검색 변경
    function handleTeacherNameSearch(name: string) {
        if(!name){
            changeUserQueryParams({name:""});
            return;
        }
        //선생님 이름 암호화
        changeUserQueryParams({name:aesCBCEncrypt(name)});
    }
    //반 선택 옵션 변경
    function handleClassSelectOptions(class_id: number) {
        changeUserQueryParams({class_id:class_id});
    }


    useEffect(() => {
        getClassList();
        getTeacherList();
    }, []);


    return (
        loading ? <Loading /> : (
        <>
            <PageHeaderTitleButtonStyle>
                <p className="header-title">선생님 관리</p>
                <div className="button-wrap">
                    <SolidPrimaryBtn className="default-btn" onClick={() => {openModal('createTeacher');initRequestTeacher();}}>
                        선생님 등록
                    </SolidPrimaryBtn>
                </div>
            </PageHeaderTitleButtonStyle>
            <ArticleWrap>
                <FilterContainer>
                    <FilterWrap>
                        <label>직책</label>
                        <SelectOption optionData={roleSelectOptions}
                                      defaultValue={userQueryParams.role_number}
                                      onChange={(role_number:number)=>{handleRoleSelectOptions(role_number)}}/>
                    </FilterWrap>
                    <FilterWrap>
                        <label>담당 반</label>
                        <SelectOption optionData={classSelectOptions}
                                      defaultValue={userQueryParams.class_id}
                                      onChange={(class_id:number) => {handleClassSelectOptions(class_id)}}/>
                    </FilterWrap>
                    <FilterWrap>
                        <label>선생님 이름</label>
                        <input type="text"
                               placeholder="선생님 이름을 입력하세요."
                               onChange={(e) => {handleTeacherNameSearch(e.target.value)}}
                               onKeyDown={(e) => {
                                    if(e.key === 'Enter'){
                                        getTeacherList();
                                    }
                               }}/>
                    </FilterWrap>

                    <SolidPrimarySubBtn className="default-btn" onClick={getTeacherList}>조회</SolidPrimarySubBtn>
                </FilterContainer>

                <PageArticleWrap>
                    <article className="list-content-container">
                        <div className="article-header" style={{marginBottom: '1rem'}}>
                            <p><span className="article-header-title">선생님 목록</span></p>
                            <JoinNavWrap>
                                <CheckBoxWrap>
                                    <CustomCheckbox id="all-approval" type="checkbox"
                                                    onClick={() => {setAllApprovalCheck(!allApprovalCheck)}} checked={allApprovalCheck}/>
                                    <label htmlFor="all-approval">승인완료 숨기기</label>
                                </CheckBoxWrap>
                                <OutlinePrimaryBtn type="button" className="default-btn" onClick={updateAllApproval}>
                                    일괄 승인
                                </OutlinePrimaryBtn>
                            </JoinNavWrap>
                        </div>
                        {teacherList.length === 0 ? (
                            <NoDataWrap>
                                <NoDataWithImageText text={NoTeacherDataText}/>
                            </NoDataWrap>
                        ):(
                            <TeacherListViewer teacherList={teacherList}
                                               allApprovalCheck={allApprovalCheck}
                                               allSelectTeacherCheck={allSelectTeacherCheck}
                                               selectTeacherIdList={selectTeacherIdList}
                                               setAllSelectTeacherCheck={setAllSelectTeacherCheck}
                                               handleSelectTeacherId={handleSelectTeacherId}
                                               handleAllSelectTeacherId={handleAllSelectTeacherId}
                                               updateApproval={updateApproval}/>
                        )}
                    </article>
                </PageArticleWrap>
            </ArticleWrap>
            {/*content에 렌더링할 컴포넌트를 전달하여 최신 상태로 리렌더링*/}
            <DefaultModalComponent isOpen={modalProps.isOpen}
                                    content={TeacherModalContent()}
                                    button={TeacherModalContent()}
                                   type={modalProps.type}
                                   isClose={modalProps.isClose}
                                   title={modalProps.title} />
        </>
        )
    )
}